module.exports = __webpack_public_path__ + "0a30c50acde909b2af670e4bfb6084dd.woff2";